import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

type AlertType = 'info';


export default /*#__PURE__*/_defineComponent({
  __name: 'CAlert',
  props: {
    type: { default: 'info' },
    text: null
  },
  setup(__props: any) {

const props = __props as { type: AlertType, text: string };



const alert = computed(() => {
    const temp = {
        class: '',
        icon: [] as string[]
    };
    switch (props.type) {
        case 'info':
            temp.class = 'bg-gray-lightest border-gray-light';
            temp.icon = ['fa-solid', 'fa-circle-info'];
            break;
    }
    return temp;
});

return { __sfc: true,props, alert }
}

})